import {
  CONSTANT_DELIVERY_ADDRESS,
  CONSTANT_DELIVERY_TIME,
  CONSTANT_ORDER_TYPE,
  CONSTANT_ORDER_TYPE_DELIVERY,
  CONSTANT_ORDER_TYPE_DINEIN,
  CONSTANT_ORDER_TYPE_PICKUP,
} from "../../constants/strings";
export class orderTypeHelper {
  static setOrderType(value) {
    sessionStorage.setItem(CONSTANT_ORDER_TYPE, value);
  }
  static setOrderTypePickup() {
    sessionStorage.setItem(CONSTANT_ORDER_TYPE, CONSTANT_ORDER_TYPE_PICKUP);
  }
  static setOrderTypeDelivery() {
    sessionStorage.setItem(CONSTANT_ORDER_TYPE, CONSTANT_ORDER_TYPE_DELIVERY);
  }
  static setOrderTypeDineIn() {
    sessionStorage.setItem(CONSTANT_ORDER_TYPE, CONSTANT_ORDER_TYPE_DINEIN);
  }
  static isDelivery() {
    return (
      sessionStorage.getItem(CONSTANT_ORDER_TYPE) ===
      CONSTANT_ORDER_TYPE_DELIVERY
    );
  }
  static isPickup() {
    return (
      sessionStorage.getItem(CONSTANT_ORDER_TYPE) === CONSTANT_ORDER_TYPE_PICKUP
    );
  }
  static isDineIn() {
    return (
      sessionStorage.getItem(CONSTANT_ORDER_TYPE) === CONSTANT_ORDER_TYPE_DINEIN
    );
  }
  static getDeliveryAddress() {
    return sessionStorage.getItem(CONSTANT_DELIVERY_ADDRESS);
  }
  static getDeliveryTime() {
    return sessionStorage.getItem(CONSTANT_DELIVERY_TIME);
  }
  static setDeliveryAddress(value) {
    sessionStorage.setItem(CONSTANT_DELIVERY_ADDRESS, value);
  }
  static setDeliveryTime(value) {
    sessionStorage.setItem(CONSTANT_DELIVERY_TIME, value);
  }
  static removeOrderType() {
    sessionStorage.removeItem(CONSTANT_ORDER_TYPE);
  }
  static removeDeliveryAddress() {
    sessionStorage.removeItem(CONSTANT_DELIVERY_ADDRESS);
  }
  static clear() {
    sessionStorage.removeItem(CONSTANT_ORDER_TYPE);
    sessionStorage.removeItem(CONSTANT_DELIVERY_ADDRESS);
    sessionStorage.removeItem(CONSTANT_DELIVERY_TIME);
  }
  static getOrderType() {
    return sessionStorage.getItem(CONSTANT_ORDER_TYPE);
  }
  static mapOrderType(menuType) {
    switch (menuType) {
      case CONSTANT_ORDER_TYPE_DELIVERY:
        return "Delivery";
      case CONSTANT_ORDER_TYPE_PICKUP:
        return "Takeaway";
      case CONSTANT_ORDER_TYPE_DINEIN:
        return "EatIn";
      default:
        return null;
    }
  }
}
